import styled, { css } from 'styled-components';

const directions = (vertical) => (vertical ? ['top', 'bottom'] : ['left', 'right']);

const FlexContainer = styled.div`
  display: flex;
  flex-direction: ${({ vertical }) => (vertical ? 'column' : 'row')};
  ${({ background }) =>
    background &&
    css`
      background-color: ${background};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
  ${({ width }) =>
    width &&
    css`
      width: ${width};
      min-width: ${width};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
      min-height: ${height};
    `}
  ${({ centered }) =>
    centered &&
    css`
      justify-content: space-between;
      align-items: center;
    `}
  ${({ vertical, inline }) =>
    !vertical &&
    inline &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
  ${({ baseline }) =>
    baseline &&
    css`
      align-items: baseline;
    `}
  ${({ gap, vertical }) =>
    gap &&
    css`
    margin-${directions(!!vertical)[0]}: -${gap};
    margin-${directions(!!vertical)[1]}: -${gap};
    & > * {
      padding-${directions(!!vertical)[0]}: ${gap};
      padding-${directions(!!vertical)[1]}: ${gap};
    }
  `}
`;

export default FlexContainer;

export const FlexPadding = styled.div`
  flex-grow: 1;
  overflow: auto;
`;



// WEBPACK FOOTER //
// ./components/layout/FlexContainer.js